import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Handsontable, { CellCoords } from 'handsontable';
import { environment } from 'src/environments/environment';
import { ColumnSettings } from 'handsontable/settings';
import { GetPageAtterrissageListingGQL } from '../../../../graphql/generated';
import { forkJoin, map, Observable, Subject } from 'rxjs';
import { extractEdgesAndNodes } from '../../graphql/operators/extract-edges-and-nodes';
import { DataChange } from '../../handsontable/types/data-change.interface';
import { PagesAtterrissageService } from '../../services/pagesAtterrissage.service';
import { HotTableRegisterer } from '@handsontable/angular';
import { UserService } from '../../services/user.service';
import { frFR, registerLanguageDictionary } from 'handsontable/i18n';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-pages-atterissage',
  templateUrl: './pages-atterissage.component.html',
  styleUrls: ['./pages-atterissage.component.scss'],
})
export class PagesAtterissageComponent implements OnInit {
  private hotRegisterer = new HotTableRegisterer();
  @Input() ouvrageId: number;
  @Input() statutOuvrage: string;
  @Input() customCellProps: Array<Handsontable.CellMeta> = [];
  @Output() sendDataset: EventEmitter<Array<any>> = new EventEmitter();
  @Output() onDataChange: EventEmitter<any> = new EventEmitter();
  @Output() onPageDelete: EventEmitter<any> = new EventEmitter();
  @Output() onLoadingDone: EventEmitter<any> = new EventEmitter();
  @Input() resetDataset: Observable<void> = new Subject();

  idTable = 'pages';
  pages: any = [];
  dataChanges: Array<DataChange> = [];
  columns: Array<ColumnSettings>;
  settings: Handsontable.GridSettings;
  datasetCopy: Array<any>;
  rowToAddNumber: number = 1;
  text: string;
  display: boolean = false;
  idTextEditor: CellCoords;

  constructor(
    private service: GetPageAtterrissageListingGQL,
    private pageAtterrissageService: PagesAtterrissageService,
    public userService: UserService,
    private messageService: MessageService,
  ) {
    this.initColumns();
    this.initSettings();
  }

  private initColumns(): void {
    let self = this;
    this.columns = [
      {
        data: 'verouille',
        title: 'Verrouillage',
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        validator: function validateUnique(value, callback) {
          return callback(true);
        },
      },
      {
        data: 'idPage',
        title: 'Id',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        width: 200,
        className: 'label',
        validator: function validateUnique(value, callback) {
          var data = this.instance.getDataAtCol(this.col);
          var index = data.indexOf(value);
          var valid = true;
          if (index > -1 && this.row !== index) {
            valid = false;
          }
          return callback(valid);
        },
      },
      {
        data: 'titre',
        title: 'Titre de la page',
        renderer: 'html',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        width: 200,
        className: 'label open_text_editor',
        validator: function testValidator(value, callback) {
          return callback(true);
        },
      },
      {
        data: 'minilien',
        title: 'Minilien',
        readOnly: true,
        type: 'text',
        width: 200,
        className: 'label',
      },
      {
        readOnly: true,
        className: 'htCenter htMiddle',
        title: 'Prévisualisation',
        renderer(instance, td, row, col, prop, value, cellProperties) {
          var lienFichier = self.pages[row].lienFichier;
          if (lienFichier !== null && typeof lienFichier !== 'undefined') {
            td.innerHTML =
              '<a href="' +
              lienFichier +
              '" target="_blank" class="pi pi-link"></a>';
          }
          return td;
        },
      },
      {
        readOnly: true,
        title: 'Complétion RN',
        renderer(instance, td, row, col, prop, value, cellProperties) {
          var tauxRemplissage = self.pages[row].taux_remplissage_rn;
          td.innerHTML =
            '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
            tauxRemplissage +
            '" class="p-progressbar p-component p-progressbar-determinate"><div' +
            ' class="p-progressbar-value p-progressbar-value-animate ng-star-inserted" style="display: flex; width: ' +
            tauxRemplissage +
            '%;"><div class="p-progressbar-label ng-star-inserted"' +
            ' style="display:' +
            ' flex;">' +
            tauxRemplissage +
            '%</div></div></div>';
          td.className = 'htCenter htMiddle';
          return td;
        },
      },
      {
        readOnly: true,
        title: 'Complétion Medias',
        renderer(instance, td, row, col, prop, value, cellProperties) {
          var tauxRemplissage = self.pages[row].taux_remplissage_media;
          td.innerHTML =
            '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
            tauxRemplissage +
            '" class="p-progressbar p-component p-progressbar-determinate"><div' +
            ' class="p-progressbar-value p-progressbar-value-animate ng-star-inserted" style="display: flex; width: ' +
            tauxRemplissage +
            '%;"><div class="p-progressbar-label ng-star-inserted"' +
            ' style="display:' +
            ' flex;">' +
            tauxRemplissage +
            '%</div></div></div>';
          td.className = 'htCenter htMiddle';
          return td;
        },
      },
      {
        data: 'actif',
        title: 'Actif',
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        width: 200,
        className: 'label',
      },
    ];
  }

  private initSettings(): void {
    var self = this;
    registerLanguageDictionary(frFR);

    this.settings = {
      allowInsertRow: true,
      language: frFR.languageCode,
      fillHandle: {
        autoInsertRow: false,
        direction: 'vertical',
      },
      contextMenu: {
        items: {
          remove_row: {
            name: 'Supprimer',
            disabled() {
              if (typeof this !== 'undefined') {
                let selected = this.getSelectedLast() as Array<any>;
                let row = selected[0];
                let page = self.pages[row];
                if (page.ressourcesNumeriques.length > 0) {
                  return true;
                }
              }

              return false;
            },
          },
          edit_text: {
            name: 'Editer le titre',
            callback(key, selection, clickEvent) {
              let row = selection[0]['start']['row'];
              let id = self.pages[row].id;
              let coords: CellCoords = new CellCoords(row, 1);

              self.idTextEditor = coords;
              self.display = true;
              self.text = self.pages[row]['titre'] as string;
            },
          },
        },
      },
      filters: true,
      dropdownMenu: [
        'filter_by_condition',
        'filter_by_value',
        'filter_action_bar',
      ],
      selectionMode: 'multiple',
      copyPaste: true,
      licenseKey: environment.hotLicenseKey,
      afterOnCellMouseDown: (event, coords, TD) => {
        // if (TD.className.includes("open_text_editor")) {
        //   self.idTextEditor = coords;
        //   self.display = true;
        //   self.text = TD.innerHTML as string
        // }
      },
      cells: (row, col) => {
        const instance = this.hotRegisterer.getInstance(this.idTable);
        if (!instance) return {};

        const data = instance.getSourceDataAtRow(row);
        if (data && col === 1) {
          const verouille = this.pages[row].verouille;
          return { readOnly: verouille === true };
        }
        return {};
      },
      // hiddenColumns: {columns: [this.columns.findIndex(c => c.title === 'searchContent')]} // hide searchContent column
    };

    if (!this.userService.canEdit()) {
      this.settings.hiddenColumns = {
        columns: [
          this.columns.findIndex((c) => c.title === 'Prévisualisation'),
        ],
      };
    }
  }

  ngOnInit() {
    this.loadPageAtterrissage();
  }

  loadPageAtterrissage(ids?: any) {
    let variables = {};
    let filterOuvrageId = {};
    filterOuvrageId['ouvrage__id'] = this.ouvrageId;
    variables = {
      filter: JSON.stringify(filterOuvrageId),
    };
    if (ids) {
      const idsString = Array.isArray(ids) ? ids.join(',') : ids.toString();
      variables = {
        ...variables,
        ids: idsString,
      };
    }

    this.service
      .watch(variables)
      .valueChanges.pipe(
        map((result) => result.data.getPageAtterrissageListing),
        extractEdgesAndNodes(),
      )
      .subscribe({
        next: (value) => {
          const enrichPages = this.enrichData(value);
          if (!this.pages || this.pages.length === 0) {
            this.pages = enrichPages;
          } else {
            enrichPages.forEach((element) => {
              const pagesIndex = this.pages.findIndex((p) => Number.parseInt(p.id) === Number.parseInt(element['id']));
              console.log(pagesIndex);
              if (pagesIndex === -1) {
                this.pages.push(element);
              } else {
                this.pages[pagesIndex] = element;
              }
            });
          }
          this.hotRegisterer.getInstance(this.idTable).loadData(this.pages);
          this.onLoadingDone.emit();
        },
        error: (err) => {},
      });
  }

  enrichData(value: any) {
    var enrichDatas: Array<Object> = [];

    value.forEach(function (item) {
      var newItem = item;
      newItem.minilien =
        item.miniliens.length > 0 ? item.miniliens[0].url_courte : null;
      newItem.lienFichier =
        item.miniliens.length > 0 ? item.miniliens[0].url_longue : null;
      enrichDatas.push(newItem);
    });

    return enrichDatas;
  }

  saveChanges(event) {
    this.dataChanges = event;
    this.onDataChange.emit(this.dataChanges);
    let instance = this.hotRegisterer.getInstance(this.idTable);
  }

  saveAllChanges() {
    this.onDataChange.emit(this.dataChanges);
  }

  createPageAtterrisage($event) {
    const amount = $event.amount;

    this.pageAtterrissageService
      .createPageAtterissage(this.ouvrageId, amount)
      .subscribe({
        next: (data) => {
          // this.loadPageAtterrissage()

          // this.pages.push(data)
          for (let i = 0; i < amount; i++) {
            let index = $event.row + i;
            this.pages[index]['id'] = data[i]['id'];
          }
          // this.hotRegisterer.getInstance(this.idTable).render();
        },
        error: (err) => {},
      });
  }

  insertRow() {
    let ressourcesCount = this.pages.length;
    this.hotRegisterer
      .getInstance(this.idTable)
      .alter('insert_row_below', ressourcesCount, this.rowToAddNumber);
    this.rowToAddNumber = 1;
  }

  deletePageAtterrissage($event: any) {
    const ids: any[] = $event.ids;

    // Création d'un tableau de requêtes de suppression pour chaque id de page à supprimer
    const requests = ids.map(idPage => this.pageAtterrissageService.deletePageAtterissage(idPage));

    //forkJoin est utulisé pour attendre que toutes les requêtes de suppression soient terminées avant de mettre à jour l'interface utilisateur
    forkJoin(requests).subscribe({
      next: () => {
        ids.forEach(idPage => {
          const pageId = this.pages.find((page) => page.id === idPage)?.idPage;
          this.onPageDelete.emit(pageId);
        });
        this.messageService.add({
          key: 'pages_update',
          severity: 'success',
          summary: 'Suppression terminée',
        });
      },
      error: (err) => {},
    });
  }

  resetDatasetHistory() {
    if (!this.hotRegisterer.getInstance(this.idTable).isDestroyed) {
      this.hotRegisterer
        .getInstance(this.idTable)
        .getCellsMeta()
        .forEach((cellMeta) => {
          if (cellMeta.className?.toString().includes('edited-cell')) {
            cellMeta.className = cellMeta.className
              .toString()
              .replace(' edited-cell', '');
            this.hotRegisterer
              .getInstance(this.idTable)
              .setCellMetaObject(cellMeta.row, cellMeta.col, cellMeta);
          }
        });
      this.hotRegisterer.getInstance(this.idTable).render();
    }
  }

  setTextCell() {
    let instance = this.hotRegisterer.getInstance(this.idTable);

    if (typeof this.pages[this.idTextEditor.row] !== 'undefined') {
      var PREFIX = '<p>';
      var SUFFIX = '</p>';
      let text = this.text;
      if (text.startsWith(PREFIX)) {
        text = this.text.slice(PREFIX.length);
      }

      if (text.endsWith(SUFFIX)) {
        text = text.slice(0, -SUFFIX.length);
      }

      instance.setDataAtCell(
        this.idTextEditor.row,
        this.idTextEditor.col,
        text,
      );
    }
  }
}
